import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { normalizeProvider } from "@smithy/core";
export var DEFAULT_UA_APP_ID = undefined;
function isValidUserAgentAppId(appId) {
  if (appId === undefined) {
    return true;
  }
  return typeof appId === "string" && appId.length <= 50;
}
export function resolveUserAgentConfig(input) {
  var _input$userAgentAppId;
  var normalizedAppIdProvider = normalizeProvider((_input$userAgentAppId = input.userAgentAppId) !== null && _input$userAgentAppId !== void 0 ? _input$userAgentAppId : DEFAULT_UA_APP_ID);
  return _objectSpread(_objectSpread({}, input), {}, {
    customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent,
    userAgentAppId: function () {
      var _userAgentAppId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var appId, _input$logger, _input$logger$constru, logger;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return normalizedAppIdProvider();
              case 2:
                appId = _context.sent;
                if (!isValidUserAgentAppId(appId)) {
                  logger = ((_input$logger = input.logger) === null || _input$logger === void 0 ? void 0 : (_input$logger$constru = _input$logger.constructor) === null || _input$logger$constru === void 0 ? void 0 : _input$logger$constru.name) === "NoOpLogger" || !input.logger ? console : input.logger;
                  if (typeof appId !== "string") {
                    logger === null || logger === void 0 ? void 0 : logger.warn("userAgentAppId must be a string or undefined.");
                  } else if (appId.length > 50) {
                    logger === null || logger === void 0 ? void 0 : logger.warn("The provided userAgentAppId exceeds the maximum length of 50 characters.");
                  }
                }
                return _context.abrupt("return", appId);
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function userAgentAppId() {
        return _userAgentAppId.apply(this, arguments);
      }
      return userAgentAppId;
    }()
  });
}